import { ComboboxGroupContext } from "./ComboboxGroupContext";

export const ComboboxGroupProvider = ComboboxGroupContext.Provider;
